var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransportBus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a71f14ae-d725-496c-a657-d9435914a577",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 308.9 254.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M178.74,220.42c12.15-30.79,42.16-53.89,77.26-53.89s65.11,23.1,77.26,53.89h46.31C365.92,164.85,315.78,122.3,256,122.3s-109.92,42.55-123.57,98.12Z",
    transform: "translate(-101.55 -122.3)",
    style: {
      fill: "#ef3327"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.26,278.68c-12.15,30.78-42.16,53.89-77.26,53.89s-65.11-23.11-77.26-53.89H132.43c13.65,55.56,63.79,98.11,123.57,98.11s109.92-42.55,123.57-98.11Z",
    transform: "translate(-101.55 -122.3)",
    style: {
      fill: "#ef3327"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.45,269.1a9.8,9.8,0,0,1-10,9.58H111.56a9.8,9.8,0,0,1-10-9.58V230a9.79,9.79,0,0,1,10-9.57H400.44a9.79,9.79,0,0,1,10,9.57V269.1Z",
    transform: "translate(-101.55 -122.3)",
    style: {
      fill: "#ef3327"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportBus);
export default __webpack_public_path__ + "static/media/transport-bus.1ba692e4.svg";
export { ForwardRef as ReactComponent };